import { IApartmentFinishingSchema } from '../../../repositories/developer-card/entities/developer_special_promo/ApartmentFinishingSchema';
import { IApplicationState } from '../../../types/redux';

import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoApartmentFinishing(
  state: IApplicationState,
): IApartmentFinishingSchema | undefined {
  return getTemplateSpecialPromo(state)?.apartmentFinishing;
}
